export const projectsRunsContent = `
Organise your requirements reviews into projects and track improvements over time.

{% card title="Projects" %}
A project groups related requirements together. Each project has its own set of runs, assigned personas, and analytics. Projects can belong to your personal workspace or an organisation.
{% /card %}

{% card title="Runs" %}
A run is a single review execution. Each run captures the input requirements, review mode, selected personas, clarity score, flagged issues, and improvement suggestions. Runs are immutable once completed.
{% /card %}
`;
